export default (state = true, action = {}) => {
  switch (action.type) {
    case 'SHOW_LEADERBOARD':
      return {
      	showAd: action.shouldShowAd,
      	adUnit: action.adUnit,
      }
    default:
      return state;
  }
};